import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TlPagination} from "../../../../interfaces/general-interfaces";
import {AuthenticationHelperService} from "../../../../services/helpers/authentication-helper.service";
import {ProfileHttpService} from "../../../../services/http-services/profile/profile-http.service";
import {PostPreviewComponent} from "../../../posts/components/post-preview/post-preview.component";
import {PAGES_AND_PATHS} from "../../../../constants/pages-and-paths";
import {RouterLink} from "@angular/router";
import {NgForOf, NgIf} from "@angular/common";
import {UserRoles} from "../../../../enums/general-enums";
import {CheckActiveRoleModule} from '../../../../pipes/check-active-role/check-active-role.module';

@Component({
  selector: 'tl-posts-tab',
  standalone: true,
  imports: [
    PostPreviewComponent,
    RouterLink,
    NgForOf,
    NgIf,
    CheckActiveRoleModule
  ],
  templateUrl: './posts-tab.component.html',
})
export class PostsTabComponent implements OnInit, OnChanges {
  @Input() userId!: number;
  @Input() profileData: any;
  @Input() isAuthUser = false;
  @Input() baseUrl = '';
  authUserData: any;
  posts: any[] = [];
  postsPagination: TlPagination | undefined;
  urlParams = {page: 1};
  showImageInFullScreen: any;
  isRequestFinish = false;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  protected readonly UserRoles = UserRoles;

  constructor(private authHelperService: AuthenticationHelperService,
              private profileHttpService: ProfileHttpService) {
  }
  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.userId && changes.userId.currentValue) {
      this.authUserData = this.authHelperService.getUserData;
      this.isAuthUser = this.userId == this.authUserData.id;
      this.isAuthUser = changes.userId.currentValue == this.authUserData?.id;
      this.postsPagination = undefined;
      this.isAuthUser ? this.getAuthUserPosts() : this.getUserPosts();
    }
  }

  getAuthUserPosts(): void {
    this.urlParams.page = this.postsPagination?.currentPage ? this.postsPagination.currentPage + 1 : 1;
    this.profileHttpService.getAuthUserPosts(this.urlParams).then(res => {
      this.posts = this.urlParams.page === 1 ? [...res.data] : [...this.posts, ...res.data];
      this.postsPagination = res.pagination;
      this.isRequestFinish = true;
    });
  }

  getUserPosts(): void {
    this.urlParams.page = this.postsPagination?.currentPage ? this.postsPagination.currentPage + 1 : 1;
    this.profileHttpService.getUserPosts({...this.urlParams, userId: this.userId}).then(res => {
      this.posts = this.urlParams.page === 1 ? [...res.data] : [...this.posts, ...res.data];
      this.postsPagination = res.pagination;
      this.isRequestFinish = true;
    });
  }

  onTogglePostLike(post: any): void {
    const postIndex = this.posts.findIndex(postElement => postElement.id === post.id);
    if (postIndex !== -1) {
      this.posts[postIndex].am_i_liked_this = post.am_i_liked_this;
      this.posts[postIndex].likes_count = post.likes_count;
    }
  }

  onConfirmPostDeleted(postId: string): void {
    this.posts = this.posts.filter(post => post.id !== postId);
  }

  onScroll(event: any): void {
    const threshold = 100;
    const position = event.target.scrollTop + event.target.offsetHeight;
    const height = event.target.scrollHeight;

    if (position > height - threshold && (this.urlParams.page) < (this.postsPagination?.lastPage ?? 0) && this.isRequestFinish) {
      this.isRequestFinish = false;
      this.isAuthUser ? this.getAuthUserPosts() : this.getUserPosts();
    }
  }
}
